<template>
    <MypageVisit
        :page_title="page_title"
        :icon_class="icon_class"
        :show_error.sync="show_error"
        :error_message="error_message"
        :error_level="error_level"
        :my_page_btn_flg="my_page_btn_flg"

        :golf_course="golf_course"
        :show_golf_list_flg="show_golf_list_flg"
        :selectGolf="selectGolf"
        :show_golf_list_count_flg="show_golf_list_count_flg"
    >
        <!-- 以下内容 -->
        <div v-show="code_show">
            <div class="col-sm-12 p-0">
                <div>
                    <div class="settlement_code_no" v-html="settlement_code"></div>

                    <div class="qr-code" v-show="qr_show" v-html="qr_code"></div>
                    <div class="barcode" v-show="barcode_show">
                        <svg id="barcode"></svg>
                    </div>

                    <button
                        type="button"
                        class="my-3 mypagebackbutton footer-btn-size"
                        @click="myPage">
                        マイページトップに戻る
                    </button>
                </div>
            </div>
        </div>
    </MypageVisit>
</template>

<script>
/**
 * マイページ 精算番号画面
 * */

// 共通画面項目
import MypageVisit from '../components/MyPage/MypageVisit';
// 共通JS項目
import mypageVisitMixin from '../../mixins/MyPage/mypageVisitMixin.js';
import { CODE_MASTER } from '../../config.js';
import { GET_API } from '../../constants/mypage_visit';
import validater from "../../lib/validater";

export default {
    components: {
        MypageVisit,
        validater
    },
    mixins: [
        mypageVisitMixin
    ],
    data () {
        return {
            // API情報取得
            get_api_url : 'get_settlement_no',
            api_url: '',
            get_api_url_all : '',
            // 画面表示項目
            settlement_code: '',
            code_show: false
        };
    },
    // 画面作成前
    created () {
        this.page_title = '精算番号参照';
        this.icon_class = 'icon-icon-info-profile mypage-title-icon';
    },
    // 画面値更新時
    computed: {
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize() {
            // API URL取得
            if(this.json_info[this.get_api_url].length > 0){
                this.get_api_url_all = this.api_url + this.json_info[this.get_api_url];
            }

            if(this.api_url != false){
                // データ取得
                this.getData();
            }
        },
        /** ----------------------------------------------
         * APIを使用し、データを取得
         * ---------------------------------------------- */
        getData: async function(){
            // ローディング表示
            this.$store.commit("loading/setIsOpacityLoading", true);
            var postData = {
                "OfficeCode" : this.api_office_code,
                "WebMemberID" : this.member_number,
            };

            // APIでデータ送信する
            await this.$apollo.query({
                query: GET_API,
                variables: {
                    url: this.get_api_url_all,
                    key: this.api_key,
                    data: JSON.stringify(postData),
                }
            })
            // JSON型で取得
            .then(response => {
                var data = response.data.GetMypageVisitApi.data;
                return JSON.parse(data);
            })
            .then(data => {

                if(data.Result.Status == '1'){
                    // 表示コード種類設定
                    //this.make_display_code = '0';

                    // 表示コード生成 (両方表示)
                    //if(this.make_display_code == '0'){
                        // バーコード
                        this.makeDisplayBarCode(data.SettlementNo);
                    //}else{
                        // QRコード
                        this.makeDisplayQrCode(data.SettlementNo);
                    //}

                    // 精算番号表示
                    this.settlement_code = '<h2 class="text-center">' + data.SettlementNoName + '</h2>';
                    this.qr_show = true;
                    this.code_show = true;

                // その他、メッセージがある場合
                } else if(data.Result.Message !== undefined && data.Result.Message !== null){
                    // メッセージ表示
                    this.show_error = true;
                    this.error_message = data.Result.Message;
                    this.error_level = "crit";

                // その他（システムエラー・サーバーエラー等）
                }else{
                    // メッセージ表示
                    this.show_error = true;
                    this.error_message = "エラーが発生しました。\nゴルフ場スタッフへお問い合わせください。";
                    this.error_level = "crit";
                 }
            })
            .then(e => {
                // ローディング非表示
                this.$store.commit("loading/setIsOpacityLoading", false);
            })
            .catch((e) => {
                console.log(e)  //エラーをキャッチし表示
                // メッセージ表示
                this.show_error = true;
                this.error_message = "エラーが発生しました。\nゴルフ場スタッフへお問い合わせください。";
                this.error_level = "crit";
                // ローディング非表示
                this.$store.commit("loading/setIsOpacityLoading", false);
            });
        },
    },
}
</script>

<style scoped>
.settlement_code_no {
    height: auto;
    width: 100%;
    max-width: 600px;
    margin: 10px auto 20px;
}
</style>